import axios from 'axios';
import { IpcCall, ipcCall } from '../lite/utils/ipcCall';

/**
 * @abstract
 */
export class UserService {

    static instance;

    static getInstance() {
        if (UserService.instance) {
            return UserService.instance;
        }

        if (window.ipcRenderer) {
            return UserService.instance = new IpcUserService();
        }

        return UserService.instance = new HttpUserService();
    }

    async inviteUser(email, role) {
        throw new Error('Not implemented');
    }

    async paginateUsers(page, order) {
        throw new Error('Not implemented');
    }

    async deleteUser(userId) {
        throw new Error('Not implemented');
    }

    async updateUser(userId, data) {
        throw new Error('Not implemented');
    }
}

class IpcUserService extends UserService {
    async inviteUser(email, role) {
        return ipcCall(IpcCall.InviteUser, { email, role });
    }

    async paginateUsers(page, order) {
        return ipcCall(IpcCall.PaginateUsers, { page, order });
    }

    async deleteUser(userId, isAdmin = false) {
        return ipcCall(IpcCall.DeleteUser, { userId, isAdmin });
    }

    async updateUser(userId, data, isAdmin = false) {
        return ipcCall(IpcCall.UpdateUser, { userId, data, isAdmin });
    }
}

class HttpUserService extends UserService {
    async inviteUser(email, role) {
        return axios.post('/api/company/users/invite', {
            email,
            role,
        });
    }

    async paginateUsers(page, order) {
        return axios.get('/api/company/users', {
            params: {
                page,
                order,
            },
        });
    }

    async deleteUser(userId, isAdmin = false) {
        return axios.delete(`/api/${isAdmin ? 'admin/' : ''}users/${userId}`);
    }

    async updateUser(userId, data, isAdmin = false) {
        return axios.put(`/api/${isAdmin ? 'admin/' : ''}users/${userId}`, data);
    }
}
